import React, { FC } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { SteamVoucherCard } from '@entities/voucher';
import { getCountryUrlByVoucher } from '@entities/country';
import { SteamAccountVoucher } from '@entities/tsp';
import { steamGiftCardClickGtm } from '@shared/lib/gtm/redesign';
interface SteamVouchersListProps {
  vouchers: SteamAccountVoucher[] | null;
  countryVouchers: {
    country: string;
    icon: string;
  }[];
}
const toGiftCardAmount = (label?: string) => {
  const digits = (label || '').replace(/[^\d.,]/g, '').replace(',', '.');
  return digits || label || '';
};
const SteamVouchersList: FC<SteamVouchersListProps> = ({
  vouchers,
  countryVouchers
}) => <SteamVouchersListWrapper>
    {vouchers?.map(voucher => <Link key={`${voucher.features?.country_web}-${voucher.features?.buttonLabel}`} href={`/steam-gifts?serviceId=${voucher.serviceId}`} onClick={() => {
    steamGiftCardClickGtm(toGiftCardAmount(voucher.features?.buttonLabel));
  }}>
        <SteamVoucherCard fullWidth voucher={voucher} countryUrl={getCountryUrlByVoucher(voucher, countryVouchers)} />
      </Link>)}
  </SteamVouchersListWrapper>;
export default SteamVouchersList;
const SteamVouchersListWrapper = /*#__PURE__*/styled('div')({
  name: "SteamVouchersListWrapper",
  class: "sxlvjy3",
  propsAsIs: false
});

require("./SteamVouchersList.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamVouchersList.tsx");